import { render, staticRenderFns } from "./AllergiesSensitivities.vue?vue&type=template&id=10cc1431&"
import script from "./AllergiesSensitivities.vue?vue&type=script&lang=js&"
export * from "./AllergiesSensitivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports